import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import { APIService } from '@/services/APIService';

export class api_dds_booking extends APIService {
  constructor(api_base_url, is_dummy = false) {
    super(api_base_url);
    // this.is_dummy = true;
  }
  getMyFutureBooking(uid, school_code){
    var self  = this;
    const url = `${this.api_base_url}/api/iot/getMyFutureBooking.php`;
    var dummy_response = {
      slots: [
        {
          start_at: '12:00 PM',
          end_at: '12:55 PM',
          status: 'IDLE',
          username: ""
        },
        {
          start_at: '1:00 PM',
          end_at: '1:55 PM',
          status: 'IDLE',
          username: ""
        }
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          uid: uid,
        }
      }).then(response => response.data);
    }
  }
  getExperimentSetStatus(school_code, experiment, equipment_id){
    var self = this;
    const url = `${this.api_base_url}/api/iot/getExperimentSetStatus.php`;
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  getSlotsByDate(date, school_code, experiment, equipment_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSlotsByDate.php`;
    var dummy_response = {
      slots: []
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          date: date,
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  releaseSlot(slot_id, uid ,auth_token) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/releaseSlot.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('slot_id', slot_id);
    bodyFormData.set('uid', uid);
    bodyFormData.set('auth_token', auth_token);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  enterLab(booking_id, uid, school_code, experiment, equipment_id, auth_token, role, user_level) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/enterLab.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('booking_id', booking_id);
    bodyFormData.set('uid', uid);
    bodyFormData.set('school_code', school_code);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('auth_token', auth_token);
    bodyFormData.set('role', role);
    bodyFormData.set('user_level', user_level);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  enterGroupLab(slot, uid, school_code, experiment, equipment_id, auth_token, role, user_level) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/enterGroupLab.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('slot', slot);
    bodyFormData.set('uid', uid);
    bodyFormData.set('school_code', school_code);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('auth_token', auth_token);
    bodyFormData.set('role', role);
    bodyFormData.set('user_level', user_level);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  getSchoolInfo(school_code) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSchoolInfo.php`;
    var dummy_response = {
      slots: [
        {
          start_at: '12:00 PM',
          end_at: '12:55 PM',
          status: 'IDLE',
          user_id: ""
        },
        {
          start_at: '1:00 PM',
          end_at: '1:55 PM',
          status: 'IDLE',
          user_id: ""
        }
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
        }
      }).then(response => response.data);
    }
  }
  getEquipmentAndBookingStatus(booking_id, school_code, experiment, equipment_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getEquipmentAndBookingStatus.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          booking_id: booking_id, 
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  getEquipmentAndGroupExperimentStatus(group_slot_id, school_code, experiment, equipment_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getEquipmentAndGroupExperimentStatus.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          group_slot_id: group_slot_id, 
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  getSchoolExperimentSetInfo(school_code, experiment, equipment_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSchoolExperimentSetInfo.php`;
    var dummy_response = {
      slots: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  bookSlot(slot_id, auth_token, username, uid) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/bookSlot.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('slot_id', slot_id);
    bodyFormData.set('auth_token', auth_token);
    bodyFormData.set('uid', uid);
    bodyFormData.set('username', username);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }  
  getSchoolOpenedExperiment(school_code, date, show_all=false) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSchoolOpenedExperiment.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          date: date,
          show_all: show_all
        }
      }).then(response => response.data);
    }
  }
  getSchoolOpenedExperimentForStudent(school_code, date, uid, show_all=false) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSchoolOpenedExperimentForStudent.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          date: date,
          uid: uid,
          show_all: show_all
        }
      }).then(response => response.data);
    }
  }
  getUserDailyBookingByExperiment(school_code, uid, display_name, experiment, equipment_id, date){
    var self = this;
    const url = `${this.api_base_url}/api/iot/getUserDailyBookingByExperiment.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          uid: uid,
          display_name: display_name,
          experiment: experiment,
          equipment_id: equipment_id,
          date: date,
        }
      }).then(response => response.data);
    }
  }
  returnBooking(school_code, uid, id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/returnBooking.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_code', school_code);
    bodyFormData.set('uid', uid);
    bodyFormData.set('id', id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  
  lockBooking(school_code, id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/school/lockBooking.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_code', school_code);
    bodyFormData.set('id', id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  unlockBooking(school_code, id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/school/unlockBooking.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_code', school_code);
    bodyFormData.set('id', id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }
  cancelBooking(school_code, id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/management/school/cancelBooking.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_code', school_code);
    bodyFormData.set('id', id);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }  
  getSchoolWeekBookings(school_code, experiment, equipment_id, from, to) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSchoolWeekBookings.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id,
          from: from,
          to: to,
        }
      }).then(response => response.data);
    }
  }
  getOngoingGroupExperimentByUserRight(school_code, uid) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getOngoingGroupExperimentByUserRight.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          uid: uid,
        }
      }).then(response => response.data);
    }
  }
}
